/**
 * UpSellItems - styled components
 */
import styled from 'styled-components'
import Collapse from 'antd/lib/collapse'

const mobileQuery = '(max-width: 1099px)'

export const DesktopSlot = styled.section`
  margin-top: var(--spacing-16);
  background: var(--neutral-white);
  border: var(--border-regular) solid var(--neutral-border-light);
  padding: var(--spacing-12) var(--spacing-16) var(--spacing-16);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  .list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-12);
  }

  .row {
    display: flex;
    align-items: center;
    gap: var(--spacing-12);
    border-bottom: 1px solid var(--neutral-border-light);
    padding-bottom: 12px;
  }

  .row:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }

  @media ${mobileQuery} {
    display: none;
  }
`

export const SectionTitle = styled.p`
  margin: 0;
  font: 500 14px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--neutral-darkest);
`

export const CollapseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: var(--spacing-12);

  .headerCopy {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
  }

  .suggestedCount {
    margin: 0;
    font: 400 12px/18px var(--font-inter);
    color: var(--neutral-secondary);
  }
`

export const ExpandMark = styled.span`
  position: relative;
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    background: var(--neutral-darkest);
    transform: translate(-50%, -50%);
  }

  &::before {
    width: 12px;
    height: 1.5px;
  }

  &::after {
    width: 1.5px;
    height: 12px;
  }
`

export const MobileCollapse = styled(Collapse)`
  display: none;
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-16);
  background: var(--neutral-white);
  border: var(--border-regular) solid var(--neutral-border-med);
  padding: var(--spacing-16);
  border-radius: unset;

  @media ${mobileQuery} {
    display: block;
  }

  .ant-collapse-item {
    border: none;
  }

  .ant-collapse-header {
    padding: 0 !important;
    color: var(--neutral-darkest) !important;
    line-height: 20px !important;
  }

  .ant-collapse-content-box {
    padding: var(--spacing-16) 0 0 !important;
  }

  .list {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-12);
  }

  .row {
    display: flex;
    align-items: center;
    gap: var(--spacing-12);
    border-bottom: 1px solid var(--neutral-border-light);
    padding-bottom: 12px;
  }

  .row:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const Thumbnail = styled.img`
  width: 46px;
  height: 62px;
  flex-shrink: 0;
  border-radius: var(--radius-sm);
  background: var(--lightened-cool);
  object-fit: contain;
`

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;

  .productName {
    margin: 0;
    font: 600 14px/20px var(--font-barlow);
    color: var(--neutral-darkest);
  }

  .productPrice {
    margin: 0;
    font: 400 12px/18px var(--font-inter);
    color: var(--neutral-body);
  }
`

export const AddButton = styled.button`
  appearance: none;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-8);
  height: 38px;
  padding: 0 var(--spacing-16);
  flex-shrink: 0;
  background: var(--neutral-white);
  border: var(--border-regular) solid var(--neutral-border-med);
  color: var(--neutral-darkest);
  cursor: pointer;
  font: 600 12px/20px var(--font-barlow);
  letter-spacing: 1px;
  text-transform: uppercase;

  &:hover {
    border-color: var(--neutral-body);
  }

  &:disabled {
    cursor: default;
  }
`

export const PlusIcon = styled.span`
  position: relative;
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    background: var(--neutral-darkest);
    transform: translate(-50%, -50%);
  }

  &::before {
    width: 12px;
    height: 1.5px;
  }

  &::after {
    width: 1.5px;
    height: 12px;
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/UpSellItems/styledComponents.tsx